import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "closeCircleFilled"
const CloseCircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-5.022-2.8-2.829 2.828 2.829 2.829a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414 0l-2.829-2.829L9.2 16.979a1 1 0 0 1-1.414 0l-.708-.707a1 1 0 0 1 0-1.414l2.829-2.829L7.078 9.2a1 1 0 0 1 0-1.414l.708-.708a1 1 0 0 1 1.414 0l2.828 2.829 2.829-2.829a1 1 0 0 1 1.414 0l.707.708a1 1 0 0 1 0 1.414Z"
          />
        </svg>
      }
    </span>
  )
}
export default CloseCircleFilledIcon
